var _circle;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBackdropSl2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 14,
    viewBox: "0 0 56 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 36.5,
    r: 36.5,
    fill: "#0CCE6B",
    fillOpacity: 0.13
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackdropSl2);
export default __webpack_public_path__ + "static/media/backdrop-SL2.787b5ce3a55a9faf58478aa57b61d437.svg";
export { ForwardRef as ReactComponent };